import { TableRow, TableCell, Box, Typography } from '@mui/material'
import { v4 as uuidV4 } from 'uuid'
import PopoverCell from 'components/atoms/table/PopoverCell'
import PresetTableContainer from 'components/atoms/table/PresetTableContainer'
import RowStack from 'components/atoms/container/RowStack'
import moment from 'moment'
import colors from 'styles/colors'
import ToolTipCustomized from 'components/atoms/container/ToolTipCustomized'
import { useTranslation } from 'react-i18next'

export const UserCohortPathCellHead = ({ containerProps = {} }) => {
  const { t } = useTranslation()
  return (
    <RowStack spacing={0} gap={2.5} {...containerProps}>
      <span>{`${t('company.cohortPath')}s`}</span>
      <ToolTipCustomized
        toolTip={
          <Box padding={5}>
            <Typography variant='body1Small' color={colors.White}>
              {t('company.onlyAccessIfInCohort')}
            </Typography>
          </Box>
        }
      />
    </RowStack>
  )
}

export const UserCohortPathCell = ({ user }) => {
  const { t } = useTranslation()
  console.log(user)
  return (
    <>
      {user.paths?.length ? (
        <PopoverCell
          cellValue={user?.paths.length}
          PopoverContent={() => {
            return (
              <>
                <PresetTableContainer
                  minHeight={'auto'}
                  headers={
                    <>
                      <TableCell>{t('company.cohortPath')}</TableCell>
                      <TableCell>{t('fullReport.startDate')}</TableCell>
                    </>
                  }>
                  {user.paths.map(p => {
                    return (
                      <TableRow key={uuidV4()}>
                        <TableCell>{p.goalName}</TableCell>
                        <TableCell>
                          {moment(p?.startDate).format('MMMM DD, YYYY')}
                        </TableCell>
                      </TableRow>
                    )
                  })}
                </PresetTableContainer>
                {user.licensedPaths?.length > 0 && (
                  <PresetTableContainer
                    minHeight={'auto'}
                    headers={
                      <>
                        <TableCell>{`${t('common.other')} ${t('headers.paths')}`}</TableCell>
                      </>
                    }>
                    {user.licensedPaths.map(p => {
                      return (
                        <TableRow key={uuidV4()}>
                          <TableCell>{p.leadershipPathName}</TableCell>
                        </TableRow>
                      )
                    })}
                  </PresetTableContainer>
                )}
              </>
            )
          }}
        />
      ) : (
        <TableCell>-</TableCell>
      )}
    </>
  )
}

export default UserCohortPathCell
